import { inject } from "vue";

import { evaluateProductApi, legiUploadApi, midealSelfOnboardingApi } from "./services/curo";
import {
  advisorsIntegrationServiceApiClient,
  countriesIntegrationServiceApiClient,
  zipCodeLocationIntegrationServiceApiClient,
} from "./services/integration";

export const apiClients = {
  curo: {
    legiUpload: legiUploadApi,
    midealSelfOnboarding: midealSelfOnboardingApi,
    evaluateProduct: evaluateProductApi,
  },
  integration: {
    advisors: advisorsIntegrationServiceApiClient,
    countries: countriesIntegrationServiceApiClient,
    zipCodeLocation: zipCodeLocationIntegrationServiceApiClient,
  },
};

export type ApiClientsConfig = typeof apiClients;
export const useApi = () => inject<ApiClientsConfig>("api");
